import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalEmployeeRoleDocument = gql`
  query SalesPortalEmployeeRole($supplierUUID: uuid!, $userUUID: uuid!) {
    businesses_by_pk(uuid: $supplierUUID) {
      uuid
      businesses_employees(where: { employee_uuid: { _eq: $userUUID } }) {
        employee_role
        uuid
        employee {
          contact_info {
            email
            login_email
          }
        }
      }
    }
  }
`;
export function useSalesPortalEmployeeRoleQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalEmployeeRoleQuery,
    Types.SalesPortalEmployeeRoleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalEmployeeRoleQuery,
    Types.SalesPortalEmployeeRoleQueryVariables
  >(SalesPortalEmployeeRoleDocument, options);
}
export function useSalesPortalEmployeeRoleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalEmployeeRoleQuery,
    Types.SalesPortalEmployeeRoleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalEmployeeRoleQuery,
    Types.SalesPortalEmployeeRoleQueryVariables
  >(SalesPortalEmployeeRoleDocument, options);
}
export type SalesPortalEmployeeRoleQueryHookResult = ReturnType<
  typeof useSalesPortalEmployeeRoleQuery
>;
export type SalesPortalEmployeeRoleLazyQueryHookResult = ReturnType<
  typeof useSalesPortalEmployeeRoleLazyQuery
>;
export type SalesPortalEmployeeRoleQueryResult = Apollo.QueryResult<
  Types.SalesPortalEmployeeRoleQuery,
  Types.SalesPortalEmployeeRoleQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalEmployeeRoleQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalEmployeeRoleQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalEmployeeRoleQuery,
    Types.SalesPortalEmployeeRoleQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalEmployeeRoleQuery,
    Types.SalesPortalEmployeeRoleQueryVariables
  >(SalesPortalEmployeeRoleDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalEmployeeRoleLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalEmployeeRoleLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalEmployeeRoleQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalEmployeeRoleQuery,
    Types.SalesPortalEmployeeRoleQueryVariables
  >(SalesPortalEmployeeRoleDocument, lazyOptions);
}
